import React from "react";

const NoData = () => {
  return (
    <div>
      <span className="text-xs italic text-red-500">No data</span>
    </div>
  );
};

export default NoData;
